// Replace no-js class

document.body.classList.remove('no-js');
